import React, { memo, useMemo } from 'react';
import ReactPaginate from 'react-paginate';
import './styles.css';

function GenericPagination({ onPageChange, currentPage, totalPages }) {
  const forcePage = useMemo(() => currentPage - 1, [currentPage]);
  const pageCount = useMemo(() => totalPages, [totalPages]);

  return (
    <ReactPaginate
      onPageChange={({ selected }) => onPageChange({ currentPage: selected + 1 })}
      forcePage={forcePage}
      pageCount={pageCount}
      pageRangeDisplayed={5}
      renderOnZeroPageCount={null}
      containerClassName="generic-pagination-container"
      breakLinkClassName="generic-pagination-page-break-number"
      previousLinkClassName="generic-pagination-page-link-previous"
      nextLinkClassName="generic-pagination-page-link-next"
      pageLinkClassName="generic-pagination-page-link-number"
      pageClassName="generic-pagination-page-number"
      activeClassName="generic-pagination-page-active-number"
      previousClassName="generic-pagination-page-previous"
      nextClassName="generic-pagination-page-next"
      disabledClassName="generic-pagination-page-disabled-previous-and-next"
      breakLabel="..."
      nextLabel="Próxima"
      previousLabel="Anterior"
    />
  );
}

export default memo(GenericPagination);
